import { render, staticRenderFns } from "./Niscc.vue?vue&type=template&id=a86daf4a"
import script from "./Niscc.vue?vue&type=script&lang=js"
export * from "./Niscc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports